import { AnyAction } from "redux";
import { DIFFICULTIES } from "../../constants";
import { Graph } from "../../models";
import { distanceType } from "../../models/types";
import { GameState } from "./type";

export const SET_DIFFICULTIES = "SET_DIFFICULTIES";
export const SET_GAME_GRAPH = "SET_GAME_GRAPH";
export const SET_IS_PLAYING = "SET_IS_PLAYING";
export const SET_IS_STARTED = "SET_IS_STARTED";
export const SET_IS_WON = "SET_IS_WON";
export const SET_LEVEL_PASSED = "SET_LEVEL_PASSED";
export const SET_ACTIVE_GAME_ITEM = "SET_ACTIVE_GAME_ITEM";
export const SET_GAME_ANSWERS = "SET_GAME_ANSWERS";
export const SET_DISTANCE_GAME_TYPE = "SET_DISTANCE_GAME_TYPE";
export const SET_START_NODE = "SET_START_NODE";
export const SET_END_NODE = "SET_END_NODE";
export const SET_CURRENT_NODE = "SET_CURRENT_NODE";

const initialState: GameState = {
  difficulty: DIFFICULTIES.EASY,
  graph: new Graph(),
  isPlaying: false,
  isStarted: false,
  isWon: false,
  currentLevel: 1,
  activeGameItem: null,
  gameAnswers: [],
  distanceGameType: distanceType.BY_COORDINATES,
  startNode: null,
  endNode: null,
  currentNode: null,
};

const gameReducer = (
  state = initialState,
  { type, payload }: AnyAction
): GameState => {
  switch (type) {
    case SET_DIFFICULTIES: {
      return {
        ...state,
        difficulty: payload,
      };
    }

    case SET_GAME_GRAPH: {
      return {
        ...state,
        graph: payload,
      };
    }

    case SET_IS_PLAYING: {
      return {
        ...state,
        isPlaying: payload,
      };
    }

    case SET_IS_STARTED: {
      return {
        ...state,
        isStarted: payload,
      };
    }

    case SET_IS_WON: {
      return {
        ...state,
        isWon: payload,
      };
    }

    case SET_CURRENT_NODE: {
      return {
        ...state,
        currentNode: payload,
      };
    }

    case SET_LEVEL_PASSED: {
      return {
        ...state,
        currentLevel: state.currentLevel + 1,
      };
    }

    case SET_ACTIVE_GAME_ITEM: {
      return {
        ...state,
        activeGameItem: payload,
      };
    }

    case SET_GAME_ANSWERS: {
      return {
        ...state,
        gameAnswers: payload,
      };
    }

    case SET_DISTANCE_GAME_TYPE: {
      return {
        ...state,
        distanceGameType: payload,
      };
    }

    case SET_START_NODE: {
      return {
        ...state,
        startNode: payload,
      };
    }

    case SET_END_NODE: {
      return {
        ...state,
        endNode: payload,
      };
    }

    default: {
      return state;
    }
  }
};

export default gameReducer;
